import Vue from "vue";
import network from "../../../utils/network";
import axios from "axios";

const urls = {
  getMerchantMetaData: (id) => `/drawer/document/${id}/merchant-metadata`,
  getMyDocuments: `/drawer/user-documents`,
  download: (id) => `/file/download/${id}`,
  downloadPublic: (id) => `/api/file/public/${id}`,
};

/**
 * ApplicationFlow Drawer FileStorage
 */

const initState = () => {
  return {
    downloads: {}, // downloads can be "cached" since their file ID is unique, they cannot be updated
    merchantMetaData: {},
  };
};

const actions = {
  download: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let blob = await axios.get(urls.download(id), { responseType: "blob" });
      commit("saveFile", {
        id: id,
        blob: blob.data,
        type: blob.headers["content-type"],
      });
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
  downloadPublic: async ({ commit }, id) => {
    try {
      let blob = await axios.get(urls.downloadPublic(id), {
        responseType: "blob",
      });
      commit("saveFile", {
        id: id,
        blob: blob.data,
        type: blob.headers["content-type"],
      });
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
  getMerchantMetaData: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      const { data: documentMetadata } = await axios.get(
        urls.getMerchantMetaData(id)
      );
      commit("saveMerchantMetadata", { id: id, data: documentMetadata });
      return documentMetadata;
    } catch (err) {
      // logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveMerchantMetadata: (state, { id, data }) => {
    Vue.set(state.merchantMetaData, id, data);
  },
  saveFile: (state, { id, blob, type }) => {
    Vue.set(state.downloads, id, new Blob([blob], { type: type }));
  },
};

const getters = {
  getFile: (state) => (id) => {
    return state.downloads[id];
  },
  getMerchantMetaData: (state) => (id) => {
    return state.merchantMetaData[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
